import { ENV, IS_DEV } from './env';

export enum COOKIES_KEYS {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',

  ORIGIN_HOST = 'hostOrigin',
  LOGIN_PARAMS = 'loginParams',

  LOGOUT_OPTIONS = 'logoutOptions',

  KB_PAY_LINK_ACCESS_TOKEN = 'kbPayLinkAccessToken',
  KB_PAY_LINK_REFRESH_TOKEN = 'kbPayLinkRefreshToken',

  PARTNERS_CLICK_TOKEN = 'partnersClickToken',
  PARTNERS_VISITOR_ID = 'partnersVisitorId',

  INVITE_MEMBER_CODE = 'inviteMemberCode',
}

export const COOKIE_OPTIONS = {
  domain: IS_DEV
    ? 'localhost'
    : `.${ENV.NEXT_PUBLIC_DOMAIN.replace('https://', '')}`,
  path: '/',
  secure: true,
};
